import { Link, useLocation } from 'react-router-dom';

const breadcrumbMap = {
  '/purchase-orders/ingest': [
    { label: 'Purchase Orders', path: '/purchase-orders' },
    { label: 'Upload' },
  ],
  '/review': [
    { label: 'Document Queue', path: '/document-queue' },
    { label: 'Review' },
  ],
};

function Breadcrumb() {
  const location = useLocation();
  const pathname = location.pathname;

  // Check for dynamic PO detail route: /purchase-orders/:id
  const poDetailMatch = pathname.match(/^\/purchase-orders\/([a-f0-9]{24})$/);
  // Check for dynamic company detail route: /companies/:id
  const companyDetailMatch = pathname.match(/^\/companies\/([a-f0-9]{24})$/);

  let crumbs;

  if (poDetailMatch) {
    crumbs = [
      { label: 'Purchase Orders', path: '/purchase-orders' },
      { label: 'PO Details' },
    ];
  } else if (companyDetailMatch) {
    crumbs = [
      { label: 'Companies', path: '/companies' },
      { label: 'Company Details' },
    ];
  } else {
    crumbs = breadcrumbMap[pathname];
  }

  if (!crumbs) return null;

  return (
    <nav className="text-sm mb-4 flex items-center gap-1.5">
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <span key={i} className="flex items-center gap-1.5">
            {i > 0 && <span className="text-gray-400">/</span>}
            {crumb.path && !isLast ? (
              <Link to={crumb.path} className="text-gray-500 hover:text-blue-600">
                {crumb.label}
              </Link>
            ) : (
              <span className="text-gray-900 font-medium">{crumb.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}

export default Breadcrumb;
